const noImageUrl = TYROOLA.globals.staticUrl + 'images/tyres/tyroola-no-tyre-available.png';

function getImageHTML(url) {
    "use strict";

    return `<div class="pull-left cart-modal__image">
        <img width="60" height="60" alt="tyres online" src="${url}">
    </div>`;
}

function getNoImageHTML(url) {
    "use strict";

    return `<div class="pull-left cart-modal__image">
        <img 
             class="cart-modal__image cart-modal__image--missing"
             width="60" 
             height="60"
             src="${url}"
             alt="Image not available"
        >
    </div>`;
}

function renderProductImage(imageUrl) {
    "use strict";
    return imageUrl ? getImageHTML(imageUrl) : getNoImageHTML(noImageUrl);
}

export default renderProductImage;